import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

export default function Datenschutz() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-2">
            Datenschutzerklärung
          </h1>
          <p className="text-sm text-foreground-500 mb-12">
            Stand: August 2026
          </p>

          <div className="space-y-10 text-sm leading-relaxed text-foreground-700">
            {/* 1. Verantwortlicher */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                1. Verantwortlicher
              </h2>
              <div className="space-y-1">
                <p className="font-medium text-foreground-800">Florale Manufaktur Blumen Stöhr GmbH</p>
                <p>Heisfelder Straße 105</p>
                <p>26789 Leer (Ostfriesland)</p>
                <p>Deutschland</p>
              </div>
              <div className="mt-3 space-y-1">
                <p>
                  <span className="text-foreground-500">Telefon:</span>{" "}
                  <a href="tel:04914238" className="hover:text-primary-600 transition-colors">0491 4238</a>
                </p>
                <p>
                  <span className="text-foreground-500">E-Mail:</span>{" "}
                  <a href="mailto:info@blumen-stoehr.de" className="hover:text-primary-600 transition-colors">info@blumen-stoehr.de</a>
                </p>
              </div>
            </section>

            {/* 2. Allgemeines zur Datenverarbeitung */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                2. Allgemeines zur Datenverarbeitung
              </h2>
              <p>
                Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir verarbeiten Ihre personenbezogenen Daten ausschließlich im Einklang mit den Bestimmungen der Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG).
              </p>
              <p className="mt-2">
                Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen (z. B. Name, E-Mail-Adresse, Telefonnummer).
              </p>
            </section>

            {/* 3. Daten bei Nutzung der Webseite */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                3. Daten beim Besuch unserer Webseite
              </h2>
              <p>
                Beim bloßen Aufrufen unserer Webseite werden durch unseren Hosting-Provider technisch notwendige Daten automatisch erfasst und in Server-Logfiles gespeichert:
              </p>
              <ul className="mt-2 space-y-1 list-disc list-inside">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Referrer-URL (die zuvor besuchte Seite)</li>
                <li>Verwendeter Browser und ggf. Betriebssystem</li>
              </ul>
              <p className="mt-2">
                Diese Daten werden ausschließlich zur technischen Bereitstellung der Webseite und zur Gewährleistung der Systemsicherheit verwendet. Eine Zusammenführung mit anderen Datenquellen findet nicht statt.
              </p>
            </section>

            {/* 4. Keine externen Schriftarten oder eingebettete US-Dienste */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                4. Verwendung von Schriftarten und externen Ressourcen
              </h2>
              <p>
                <strong>Keine Google Fonts:</strong> Wir verwenden ausschließlich lokal im Browser verfügbare System-Schriftarten. Es findet keine Verbindung zu Google-Servern oder anderen US-amerikanischen Diensten für Schriftarten statt.
              </p>
              <p className="mt-2">
                <strong>Icons:</strong> Für die Darstellung von Icons nutzen wir Font Awesome und Remix Icon, die über ein CDN (Content Delivery Network) geladen werden. Beim Aufruf der Seite kann eine Verbindung zu Servern des CDN-Anbieters hergestellt werden. Die jeweiligen Anbieter verarbeiten dabei ggf. Ihre IP-Adresse. Weitere Informationen finden Sie in den Datenschutzerklärungen von{" "}
                <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">Cloudflare</a>{" "}
                und{" "}
                <a href="https://remixicon.com/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">Remix Icon</a>.
              </p>
            </section>

            {/* 5. Kontaktformular / Anfragen */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                5. Kontaktformular und Anfragen per E-Mail oder Telefon
              </h2>
              <p>
                Wenn Sie uns über das Kontaktformular, per E-Mail oder telefonisch kontaktieren, werden die von Ihnen angegebenen Daten (z. B. Name, E-Mail-Adresse, Telefonnummer, Nachrichtentext) zur Bearbeitung Ihrer Anfrage bei uns gespeichert.
              </p>
              <p className="mt-2">
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung von Anfragen).
              </p>
              <p className="mt-2">
                <strong>Dauer der Speicherung:</strong> Wir löschen die Daten, sobald die Speicherung für die Bearbeitung Ihrer Anfrage nicht mehr erforderlich ist, spätestens jedoch nach 12 Monaten, sofern keine gesetzliche Aufbewahrungspflicht besteht.
              </p>
            </section>

            {/* 6. Cookies */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                6. Cookies
              </h2>
              <p>
                Unsere Webseite verwendet ausschließlich technisch notwendige Cookies. Diese sind erforderlich, damit die Webseite korrekt funktioniert (z. B. zur Navigation und zur korrekten Darstellung von Inhalten).
              </p>
              <p className="mt-2">
                Wir verwenden <strong>keine Tracking-Cookies</strong>, keine Analyse-Tools (z. B. Google Analytics), keine Social-Media-Plugins und keine eingebetteten Drittanbieter-Inhalte.
              </p>
              <p className="mt-2">
                Technisch notwendige Cookies werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an technisch fehlerfreier Funktion) gesetzt.
              </p>
            </section>

            {/* 7. Externe Links */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                7. Externe Links
              </h2>
              <p>
                Unsere Webseite enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
              </p>
              <p className="mt-2">
                Beim Klicken auf einen externen Link verlassen Sie unsere Webseite. Die verlinkten Anbieter sind eigenständig für den Datenschutz auf ihren Seiten verantwortlich. Bitte beachten Sie deren Datenschutzerklärungen:
              </p>
              <ul className="mt-2 space-y-1 list-disc list-inside">
                <li>
                  <a href="https://www.fleurop.de" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">Fleurop</a>{" "}
                  (Fleurop-Partnerseite)
                </li>
                <li>
                  <a href="https://www.instagram.com/florale_manufaktur/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">Instagram</a>{" "}
                  (Meta Platforms Ireland Ltd., Datenschutzerklärung:{" "}
                  <a href="https://privacycenter.instagram.com/policy/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">privacycenter.instagram.com</a>)
                </li>
                <li>
                  <a href="https://www.facebook.com/blumenstoehr" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">Facebook</a>{" "}
                  (Meta Platforms Ireland Ltd., Datenschutzerklärung:{" "}
                  <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">facebook.com/privacy</a>)
                </li>
              </ul>
            </section>

            {/* 8. Ihre Rechte */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                8. Ihre Rechte als betroffene Person
              </h2>
              <p>Sie haben nach der DSGVO folgende Rechte:</p>
              <ul className="mt-2 space-y-1.5 list-disc list-inside">
                <li>
                  <strong>Auskunft (Art. 15 DSGVO):</strong> Sie können jederzeit Auskunft über die bei uns gespeicherten personenbezogenen Daten verlangen.
                </li>
                <li>
                  <strong>Berichtigung (Art. 16 DSGVO):</strong> Sie haben das Recht, unrichtige Daten berichtigen zu lassen.
                </li>
                <li>
                  <strong>Löschung (Art. 17 DSGVO):</strong> Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzliche Aufbewahrungspflicht besteht.
                </li>
                <li>
                  <strong>Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.
                </li>
                <li>
                  <strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen Format zu erhalten.
                </li>
                <li>
                  <strong>Widerspruch (Art. 21 DSGVO):</strong> Sie können der Verarbeitung Ihrer Daten widersprechen, sofern diese auf Art. 6 Abs. 1 lit. f DSGVO beruht.
                </li>
              </ul>
              <p className="mt-3">
                Zur Ausübung Ihrer Rechte wenden Sie sich bitte an uns unter den oben genannten Kontaktdaten.
              </p>
            </section>

            {/* 9. Beschwerde */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                9. Beschwerderecht bei der Aufsichtsbehörde
              </h2>
              <p>
                Sie haben das Recht, jederzeit bei einer Datenschutzaufsichtsbehörde Beschwerde einzulegen. Die zuständige Aufsichtsbehörde für uns ist:
              </p>
              <div className="mt-2 space-y-1">
                <p className="font-medium text-foreground-800">Die Landesbeauftragte für den Datenschutz Niedersachsen</p>
                <p>Prinzenstraße 5</p>
                <p>30159 Hannover</p>
                <p>
                  <a href="https://www.lfd.niedersachsen.de" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600 transition-colors">
                    www.lfd.niedersachsen.de
                  </a>
                </p>
              </div>
            </section>

            {/* 10. Änderungen */}
            <section>
              <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3 pb-2 border-b border-background-200/70">
                10. Änderungen dieser Datenschutzerklärung
              </h2>
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt die jeweils aktuelle Datenschutzerklärung.
              </p>
            </section>
          </div>

          <div className="mt-16 pt-6 border-t border-background-200/70 flex items-center gap-4">
            <Link to="/impressum" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Impressum
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/ki-transparenz" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              KI-Transparenz
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}